import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'

// One request, its document, and the decision. `$id` and not `$requestId`: `numericIdParam`
// is the shared parser, and it is what keeps `/appointments/requests/0x10` from opening request 16.

/** A request as a link target. No search params, so it is a plain object. */
export function registrationCardLink(requestId: number) {
  return { to: '/appointments/requests/$id', params: { id: requestId } } as const
}

export const registrationDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/appointments/requests/$id',
  params: numericIdParam,
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/registration-detail.tsx')),
})
